<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]"
        @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
            <span v-if="!$_updateActionAllowed" class="lock" :title="$gettext('Globální konfiguraci zařízení. Nelze editovat.')">S</span>
            <input type="checkbox"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label
                :for="entity.id"
                @click.stop
                v-translate>Vybrat
            </label>
        </td>
      <span class="lock" v-if="!$_updateActionAllowed" :title="$gettext('Globální konfiguraci zařízení. Nelze editovat.')" v-translate>Zamčeno</span>
      <td data-th="Název">
            {{ entity.name }}
        </td>
        <td v-if="$_readActionAllowedAllOrOwnAndGlobal" data-th="Operátor">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.name_operator }}</entity-link>
        </td>
        <td data-th="Typy zařízení">
          <entity-link :id="entity.id_device_type" type="deviceType">{{ entity.name_device_type }}</entity-link>
        </td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"/>
        <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"/>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                    v-if="$_deleteActionAllowed"
                    class="btn btn_action btn_delete"
                    :title="'Smazat' | translate"
                    @click.prevent.stop="emitDeleteDeviceConfig">
                    <translate class="translate">Smazat</translate>
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
    name: "DeviceConfigRow",
  components: { EntityLink },
    mixins: [rowActions],
    props: {
        entity: Object,
    },
    data() {
        return {
            moduleName: 'deviceConfigs',
            detailPageRouteName: 'deviceConfigDetail',
        }
    },
    methods: {
      emitDeleteDeviceConfig() {
          this.$emit('deleteDeviceConfig', String(this.entity.id))
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/DeviceConfigRow.vue